import { Spinner, SpinnerSize } from "@blueprintjs/core";
import * as React from "react";
import styled from "styled-components";

export interface IFullPageLoaderProps {
  fullHeight?: boolean;
}

const Container = styled.div`
  display: flex;
  width: 100%;
  flex: 1;
  justify-content: center;
`;

export const FullPageLoader: React.FunctionComponent<IFullPageLoaderProps> = ({
  fullHeight = true,
}) => {
  return (
    <Container style={{ height: fullHeight ? "100%" : "150px" }}>
      <Spinner size={SpinnerSize.LARGE} />
    </Container>
  );
};
